import Cookies from "js-cookie";
import { getDomainName } from "@/scripts/helpers/getUrlParams";

export const emailToCookieHandler = () => {
  const forms = document.querySelectorAll(".exp-18042");
  const cookieName = "SN_SIGNUP_USER_EMAIL";
  const domain = getDomainName();

  for (let i = 0; i < forms.length; i++) {
    const form = forms[i];
    const emailField = form.querySelector("input[type='email']");

    form.addEventListener("submit", e => {
      Cookies.set(cookieName, emailField.value, {
        domain: domain
      });
    });
  }
};
